module.exports = __webpack_public_path__ + "static/media/virgin_card_2.6bc7a001.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/components/LargeFlightCard/images/virgin_card_2.jpg
// module id = 528
// module chunks = 0